import { render, staticRenderFns } from "./ImportScreenRow.vue?vue&type=template&id=982d4bb2&"
import script from "./ImportScreenRow.vue?vue&type=script&lang=js&"
export * from "./ImportScreenRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('982d4bb2')) {
      api.createRecord('982d4bb2', component.options)
    } else {
      api.reload('982d4bb2', component.options)
    }
    module.hot.accept("./ImportScreenRow.vue?vue&type=template&id=982d4bb2&", function () {
      api.rerender('982d4bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/Settings/ImportScreenRow.vue"
export default component.exports